<template>
  <div>
    <Layout ref="layoutRef" :selectedOption="3" />
    <div class="mb-3">
      <div class="row">
        <div class="col-11"><h4>Personas</h4></div>
        <div class="col-1">
          <button class="btn-help" type="button" title="Abrir ayuda"
            @click="showModalHelp = true" aria-label="Abrir ayuda de personas">
            <span class="material-symbols-outlined">help</span>
          </button>
        </div>
      </div>
    </div>
<Modal v-model:modelValue="showModalHelp" title="Ayuda — Personas">
  <AyudaPersona />
</Modal>

    <hr>

    <DataTable
      :data="personas"
      :columns="columns"
      idField="idPersona"
      :acciones="true"
      :mostrarBotonTodos="false"
      :mostrarBotonNuevo="true"
      :mostrarBotonExcel="true"
      :mostrarInfo="false"
      :mostrarEditar="false"
      :mostrarVer="false"
      :mostrarEliminar="false"
      @create="abrirModalCrear"
    >
      <!-- Acciones por fila -->
      <template #acciones-fila="{ row }">
        <select
          class="form-select form-select-sm"
          @change="handleAction($event, row.idPersona, row.nombreCompleto)"
        >
          <option disabled selected>Seleccione...</option>
          <option value="editar">Editar</option>
          <option value="detalles">Detalles</option>
          <option value="borrar">Borrar</option>
          <option disabled></option>
          <option value="crearCita">Nueva Cita</option>
          <option value="crearNotificacion">Nueva Notificación</option>
        </select>
      </template>
    </DataTable>

    <!-- Modal Persona -->
    <div class="modal fade" id="ventanaModal" tabindex="-1" aria-hidden="true" v-if="modalWindow">
      <div class="modal-dialog modal-xl">
        <div class="modal-content">
          <div class="modal-header bg-primary">
            <h5 class="modal-title">{{ titulo }}</h5>
            <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
          </div>
          <form>
            <div class="modal-body">

              <div class="mb-3" v-if="btnEditar">
                <div class="row">
                  <div class="col-2"><label class="form-label">IdPersona</label></div>
                  <div class="col-10">
                    <input type="text" class="form-control" v-model="datoPersona.idPersona" disabled>
                  </div>
                </div>
              </div>

              <div class="mb-3">
                <div class="row">
                  <div class="col-2"><label class="form-label">Tipo Id.</label></div>
                  <div class="col-2">
                    <select class="form-control" v-model="datoPersona.idTipoIden">
                      <option v-for="t in tipoIdens" :value="t.idTipoIden" :key="t.idTipoIden">{{ t.nombre }}</option>
                    </select>
                  </div>
                  <div class="col-2"><label class="form-label">Documento</label></div>
                  <div class="col-2">
                    <input type="text" class="form-control" v-model="datoPersona.documento"
                      style="text-transform:uppercase" required>
                  </div>
                  <div class="col-2"><label class="form-label">Estado Civil</label></div>
                  <div class="col-2">
                    <select class="form-control" v-model="datoPersona.idEstadoCivil">
                      <option v-for="e in estadoCivils" :value="e.idEstadoCivil" :key="e.idEstadoCivil">{{ e.nombre }}</option>
                    </select>
                  </div>
                </div>
              </div>

              <div class="mb-3">
                <div class="row">
                  <div class="col-2"><label class="form-label">Fecha Nac.</label></div>
                  <div class="col-2">
                    <input type="date" class="form-control" v-model="datoPersona.fechaNac" required>
                  </div>
                  <div class="col-2"><label class="form-label">Sexo</label></div>
                  <div class="col-2">
                    <select class="form-control" v-model="datoPersona.sexo" required>
                      <option value="">Seleccione el género</option>
                      <option value="M">Masculino</option>
                      <option value="F">Femenino</option>
                    </select>
                  </div>
                  <div class="col-2"><label class="form-label">Teléfono</label></div>
                  <div class="col-2">
                    <input type="text" class="form-control" v-model="datoPersona.telefono"
                      style="text-transform:uppercase" required>
                  </div>
                </div>
              </div>

              <div class="mb-3">
                <div class="row">
                  <div class="col-2"><label class="form-label">Primer Nombre</label></div>
                  <div class="col-4">
                    <input type="text" class="form-control" v-model="datoPersona.primerNombre"
                      style="text-transform:uppercase" required>
                  </div>
                  <div class="col-2"><label class="form-label">Segundo Nombre</label></div>
                  <div class="col-4">
                    <input type="text" class="form-control" v-model="datoPersona.segundoNombre"
                      style="text-transform:uppercase" required>
                  </div>
                </div>
              </div>

              <div class="mb-3">
                <div class="row">
                  <div class="col-2"><label class="form-label">Primer Apellido</label></div>
                  <div class="col-4">
                    <input type="text" class="form-control" v-model="datoPersona.primerApellido"
                      style="text-transform:uppercase" required>
                  </div>
                  <div class="col-2"><label class="form-label">Segundo Apellido</label></div>
                  <div class="col-4">
                    <input type="text" class="form-control" v-model="datoPersona.segundoApellido"
                      style="text-transform:uppercase" required>
                  </div>
                </div>
              </div>

              <div class="mb-3">
                <div class="row">
                  <div class="col-2"><label class="form-label">Localidad</label></div>
                  <div class="col-4">
                    <select class="form-control" v-model="datoPersona.idLocalidad">
                      <option v-for="l in localidads" :value="l.idLocalidad" :key="l.idLocalidad">{{ l.nombre }}</option>
                    </select>
                  </div>
                  <div class="col-2"><label class="form-label">Email</label></div>
                  <div class="col-4">
                    <input type="text" class="form-control" v-model="datoPersona.email" required>
                  </div>
                </div>
              </div>

              <div class="mb-3">
                <div class="row">
                  <div class="col-2"><label class="form-label">Dirección</label></div>
                  <div class="col-10">
                    <input type="text" class="form-control" v-model="datoPersona.direccion"
                      style="text-transform:uppercase" required>
                  </div>
                </div>
              </div>

              <button @click.prevent="mostrarOcultarBloque">
                {{ mostrarBloque ? '(-) Menos información' : '(+) Más información' }}
              </button>
              <div v-if="mostrarBloque" class="mb-3 mt-2">
                <div class="row">
                  <div class="col-2"><label class="form-label">FechaReg</label></div>
                  <div class="col-10">
                    <input type="text" class="form-control" v-model="datoPersona.fechaReg" disabled>
                  </div>
                </div>
              </div>

            </div>
          </form>
          <div class="modal-footer">
            <button class="btn btn-light" @click.prevent="guardarPersona" v-if="btnCrear" title="Guardar">
              <i class="material-icons" style="font-size:32px;color:blue; cursor: pointer;">save</i>
            </button>
            <button class="btn btn-light" @click.prevent="guardarEditPersona" v-if="btnEditar" title="Actualizar">
              <i class="material-icons" style="font-size:32px;color:blue; cursor: pointer;">update</i>
            </button>
          </div>
        </div>
      </div>
    </div>

    <Footer />
  </div>
</template>

<script>
import Layout from '@/components/Layout.vue'
import Footer from '@/components/Footer.vue'
import DataTable from '@/components/DataTable.vue'
import AyudaPersona from '@/views/ayuda/AyudaPersona.vue'
import { validarForm } from '@/modules/validacionesForms.js'
import dateFormat from '@/modules/dateFormat.js'
import api from "@/services/api"
import * as $ from 'jquery'
window["$"] = $
window["jQuery"] = $
import swal from 'sweetalert'

export default {
  components: { Layout, Footer, AyudaPersona, DataTable },
  data() {
    return {
      opcionConsulta:    0,
      opcionOperaciones: 0,
      opcionDescarga:    0,
      opcionMenu:        0,
      personas:          [],
      datoPersona:       {},
      titulo:            '',
      btnCrear:          false,
      btnEditar:         false,
      modalWindow:       true,
      tipoIdens:         [],
      localidads:        [],
      estadoCivils:      [],
      mostrarBloque:     false,
      showModalHelp:     false,
      columns: [
        { field: 'documento',      label: 'Documento' },
        { field: 'nombreCompleto', label: 'Nombre' },
        { field: 'telefono',       label: 'Teléfono' },
        { field: 'email',          label: 'E-mail' },
      ],
    }
  },
  mounted() {
    this.$refs.layoutRef.toggleProcesos()
    this.$refs.layoutRef.toggleReportes()
    this.$refs.layoutRef.toggleParametros()
    this.$refs.layoutRef.toggleAyuda()
    this.opcionConsulta    = parseInt(window.sessionStorage.getItem('opcionConsulta'),    10) || 0
    this.opcionOperaciones = parseInt(window.sessionStorage.getItem('opcionOperaciones'), 10) || 0
    this.opcionDescarga    = parseInt(window.sessionStorage.getItem('opcionDescarga'),    10) || 0
    this.opcionMenu        = parseInt(window.sessionStorage.getItem('opcionMenu'),        10) || 0
    this.getDataTodos()
    this.fetchTipoIdens()
    this.fetchLocalidads()
    this.fetchEstadoCivils()
  },
  methods: {
    getFormattedDate(date) { return dateFormat.getFormattedDate(date) },
    mostrarOcultarBloque() { this.mostrarBloque = !this.mostrarBloque },
    //  Carga de datos
    getDataTodos() {
      const idEmpresa = window.sessionStorage.getItem("idEmpresa")
      api.get('/vwpersonas/idempresa/' + idEmpresa).then(response => {
        this.personas = response.data.reverse()
      })
    },
    //  Acciones de fila
    handleAction(event, idPersona, nombre) {
      const action = event.target.value
      if      (action === 'editar')            this.abrirModalEditar(idPersona)
      else if (action === 'detalles')          this.abrirEditar(idPersona)
      else if (action === 'borrar')            this.deletePersona(idPersona)
      else if (action === 'crearCita')         this.crearCita(idPersona)
      else if (action === 'crearNotificacion') this.crearNotificacion(idPersona, nombre)
      event.target.value = 'Seleccione...'
    },
    //  Validación
    validarForm() {
      const fields = ['idTipoIden','idLocalidad','idEstadoCivil','documento',
        'primerNombre','segundoNombre','primerApellido','segundoApellido',
        'fechaNac','direccion','telefono','sexo','email']
      return validarForm(this.datoPersona, fields, fields)
    },
    //  CRUD
    async guardarPersona() {
      if (this.validarForm() !== 1) return
      try {
        this.datoPersona.idEmpresa   = window.sessionStorage.getItem("idEmpresa")
        this.datoPersona.tipoPersona = 'N'
        await api.post('/personas', this.datoPersona)
        $('#ventanaModal').modal('hide')
        swal("Correcto!", "Persona creada exitosamente!", "success")
        this.getDataTodos()
      } catch { swal("Error!", "Intentelo de nuevo!", "error") }
    },
    async guardarEditPersona() {
      if (this.validarForm() !== 1) return
      try {
        await api.post('/personas', this.datoPersona)
        $('#ventanaModal').modal('hide')
        swal("Correcto!", "Persona actualizada exitosamente!", "success")
        this.getDataTodos()
      } catch (error) {
        swal("Error!", "Intentelo de nuevo!", "error")
        Object.values(error.response?.data?.errors ?? {}).forEach(e => swal(String(e)))
      }
    },
    abrirModalCrear() {
      this.datoPersona = {}
      this.titulo      = 'Crear Persona'
      this.btnCrear    = true
      this.btnEditar   = false
      this.$nextTick(() => $('#ventanaModal').modal('show'))
    },
    abrirModalEditar(idPersona) {
      this.titulo    = 'Editar Persona'
      this.btnCrear  = false
      this.btnEditar = true
      if (idPersona) api.get('/vwpersonas/' + idPersona).then(r => { this.datoPersona = r.data })
      this.$nextTick(() => $('#ventanaModal').modal('show'))
    },
    abrirEditar(idPersona) {
      if (idPersona) this.$router.push('/personaform/P/' + idPersona)
    },
    crearCita(idPersona) {
      if (idPersona) this.$router.push('/pacientecita02/' + idPersona + '/0/0')
    },
    crearNotificacion(idPersona, nombre) {
      if (idPersona) this.$router.push('/bitacoraform/' + idPersona + '/' + nombre)
    },
    async deletePersona(idPersona) {
      const ok = await swal({ title: "¿Eliminar persona?", icon: "warning",
        buttons: true, dangerMode: true })
      if (!ok) return
      try {
        await api.delete('/personas/' + idPersona)
        this.getDataTodos()
      } catch { swal("Error!", "No se pudo eliminar.", "error") }
    },
    //  Catálogos
    fetchTipoIdens() {
      api.get('/vwtipoidens').then(r => { this.tipoIdens = r.data })
    },
    fetchLocalidads() {
      api.get('/vwlocalidads').then(r => { this.localidads = r.data })
    },
    fetchEstadoCivils() {
      api.get('/vwestadocivils').then(r => { this.estadoCivils = r.data })
    },
  },
}
</script>

<style src="@/assets/css/tablaHover.css" scoped></style>
<style src="@/assets/css/listaFiltrada.css" scoped></style>
<style src="@/assets/css/listaRegistros.css" scoped></style>
